export const countries_data = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.061,
          25.388
        ]
      },
      properties: {
        country_name: "Mexico",
        wc_playedin: 15,
        wc_wins: 14,
        wc_losses: 27,
        wc_ties: 12,
        wc_champs: 0,
        success_rating: 355,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.795,
          50.696
        ]
      },
      properties: {
        country_name: "Belgium",
        wc_playedin: 12,
        wc_wins: 15,
        wc_losses: 18,
        wc_ties: 8,
        wc_champs: 0,
        success_rating: 329,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.052,
          -11.135
        ]
      },
      properties: {
        country_name: "Brazil",
        wc_playedin: 20,
        wc_wins: 73,
        wc_losses: 19,
        wc_ties: 12,
        wc_champs: 5,
        success_rating: 1961,
        third_place_wins: 2,
        second_place: 2
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -76.034,
          -8.529
        ]
      },
      properties: {
        country_name: "Peru",
        wc_playedin: 4,
        wc_wins: 4,
        wc_losses: 8,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 105,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.358,
          47.752
        ]
      },
      properties: {
        country_name: "France",
        wc_playedin: 14,
        wc_wins: 30,
        wc_losses: 21,
        wc_ties: 8,
        wc_champs: 1,
        success_rating: 798,
        third_place_wins: 2,
        second_place: 1
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -63.733,
          -15.976
        ]
      },
      properties: {
        country_name: "Bolivia",
        wc_playedin: 3,
        wc_wins: 0,
        wc_losses: 5,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 57,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -59.099,
          -22.329
        ]
      },
      properties: {
        country_name: "Paraguay",
        wc_playedin: 8,
        wc_wins: 8,
        wc_losses: 10,
        wc_ties: 9,
        wc_champs: 0,
        success_rating: 195,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          24.925,
          46.201
        ]
      },
      properties: {
        country_name: "Romania",
        wc_playedin: 7,
        wc_wins: 8,
        wc_losses: 10,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 186,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -69.947,
          -25.591
        ]
      },
      properties: {
        country_name: "Chile",
        wc_playedin: 9,
        wc_wins: 11,
        wc_losses: 16,
        wc_ties: 6,
        wc_champs: 0,
        success_rating: 285,
        third_place_wins: 1,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -97.781,
          41.401
        ]
      },
      properties: {
        country_name: "USA",
        wc_playedin: 10,
        wc_wins: 8,
        wc_losses: 19,
        wc_ties: 6,
        wc_champs: 0,
        success_rating: 221,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.92739,
          44.69974
        ]
      },
      properties: {
        country_name: "Yugoslavia",
        wc_playedin: 9,
        wc_wins: 16,
        wc_losses: 14,
        wc_ties: 7,
        wc_champs: 0,
        success_rating: 310,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.657,
          -33.241
        ]
      },
      properties: {
        country_name: "Argentina",
        wc_playedin: 16,
        wc_wins: 46,
        wc_losses: 22,
        wc_ties: 9,
        wc_champs: 2,
        success_rating: 1078,
        third_place_wins: 0,
        second_place: 3
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          29.783,
          27.876
        ]
      },
      properties: {
        country_name: "Egypt",
        wc_playedin: 2,
        wc_wins: 0,
        wc_losses: 2,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 39,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.539,
          52.039
        ]
      },
      properties: {
        country_name: "Netherlands",
        wc_playedin: 10,
        wc_wins: 28,
        wc_losses: 13,
        wc_ties: 9,
        wc_champs: 0,
        success_rating: 595,
        third_place_wins: 1,
        second_place: 3
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.603,
          46.945
        ]
      },
      properties: {
        country_name: "Switzerland",
        wc_playedin: 10,
        wc_wins: 11,
        wc_losses: 17,
        wc_ties: 5,
        wc_champs: 0,
        success_rating: 253,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.409,
          63.436
        ]
      },
      properties: {
        country_name: "Sweden",
        wc_playedin: 11,
        wc_wins: 17,
        wc_losses: 17,
        wc_ties: 12,
        wc_champs: 0,
        success_rating: 508,
        third_place_wins: 2,
        second_place: 1
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.813,
          40.521
        ]
      },
      properties: {
        country_name: "Spain",
        wc_playedin: 14,
        wc_wins: 30,
        wc_losses: 21,
        wc_ties: 8,
        wc_champs: 1,
        success_rating: 612,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          19.651,
          47.373
        ]
      },
      properties: {
        country_name: "Hungary",
        wc_playedin: 9,
        wc_wins: 15,
        wc_losses: 14,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 406,
        third_place_wins: 0,
        second_place: 2
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.89,
          47.641
        ]
      },
      properties: {
        country_name: "Austria",
        wc_playedin: 7,
        wc_wins: 12,
        wc_losses: 13,
        wc_ties: 4,
        wc_champs: 0,
        success_rating: 296,
        third_place_wins: 1,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          10.558,
          51.438
        ]
      },
      properties: {
        country_name: "Germany",
        wc_playedin: 8,
        wc_wins: 31,
        wc_losses: 8,
        wc_ties: 5,
        wc_champs: 1,
        success_rating: 712,
        third_place_wins: 3,
        second_place: 1
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          17.379165,
          49.419986
        ]
      },
      properties: {
        country_name: "Czechoslovakia",
        wc_playedin: 8,
        wc_wins: 11,
        wc_losses: 15,
        wc_ties: 4,
        wc_champs: 0,
        success_rating: 371,
        third_place_wins: 0,
        second_place: 2
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          113.643271,
          -1.903854
        ]
      },
      properties: {
        country_name: "Dutch East Indies",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 1,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 20,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.293,
          60.972
        ]
      },
      properties: {
        country_name: "Norway",
        wc_playedin: 3,
        wc_wins: 2,
        wc_losses: 3,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 63,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          19.367,
          52.331
        ]
      },
      properties: {
        country_name: "Poland",
        wc_playedin: 7,
        wc_wins: 15,
        wc_losses: 11,
        wc_ties: 5,
        wc_champs: 0,
        success_rating: 340,
        third_place_wins: 2,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -76.528,
          20.759
        ]
      },
      properties: {
        country_name: "Cuba",
        wc_playedin: 1,
        wc_wins: 1,
        wc_losses: 1,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 33,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          10.588,
          44.97
        ]
      },
      properties: {
        country_name: "Italy",
        wc_playedin: 18,
        wc_wins: 46,
        wc_losses: 21,
        wc_ties: 16,
        wc_champs: 4,
        success_rating: 1472,
        third_place_wins: 1,
        second_place: 2
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.033,
          52.449
        ]
      },
      properties: {
        country_name: "England",
        wc_playedin: 14,
        wc_wins: 26,
        wc_losses: 19,
        wc_ties: 17,
        wc_champs: 1,
        success_rating: 615,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -4.079,
          57.155
        ]
      },
      properties: {
        country_name: "Scotland",
        wc_playedin: 8,
        wc_wins: 4,
        wc_losses: 12,
        wc_ties: 7,
        wc_champs: 0,
        success_rating: 173,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          34.881,
          39.28
        ]
      },
      properties: {
        country_name: "Turkey",
        wc_playedin: 2,
        wc_wins: 5,
        wc_losses: 4,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 117,
        third_place_wins: 1,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          128.038,
          36.342
        ]
      },
      properties: {
        country_name: "Korea Republic",
        wc_playedin: 9,
        wc_wins: 6,
        wc_losses: 17,
        wc_ties: 8,
        wc_champs: 0,
        success_rating: 193,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.634,
          50.296
        ]
      },
      properties: {
        country_name: "Germany FR",
        wc_playedin: 10,
        wc_wins: 39,
        wc_losses: 12,
        wc_ties: 11,
        wc_champs: 3,
        success_rating: 1184,
        third_place_wins: 1,
        second_place: 3
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.043,
          -32.402
        ]
      },
      properties: {
        country_name: "Uruguay",
        wc_playedin: 12,
        wc_wins: 21,
        wc_losses: 19,
        wc_ties: 11,
        wc_champs: 2,
        success_rating: 703,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -3.824,
          52.097
        ]
      },
      properties: {
        country_name: "Wales",
        wc_playedin: 1,
        wc_wins: 1,
        wc_losses: 1,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 32,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -6.758,
          54.862
        ]
      },
      properties: {
        country_name: "Northern Ireland",
        wc_playedin: 3,
        wc_wins: 3,
        wc_losses: 5,
        wc_ties: 5,
        wc_champs: 0,
        success_rating: 81,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          93.161,
          63.276
        ]
      },
      properties: {
        country_name: "Soviet Union",
        wc_playedin: 7,
        wc_wins: 15,
        wc_losses: 10,
        wc_ties: 6,
        wc_champs: 0,
        success_rating: 261,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -72.844,
          4.073
        ]
      },
      properties: {
        country_name: "Colombia",
        wc_playedin: 5,
        wc_wins: 7,
        wc_losses: 9,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 123,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.273,
          42.907
        ]
      },
      properties: {
        country_name: "Bulgaria",
        wc_playedin: 7,
        wc_wins: 4,
        wc_losses: 15,
        wc_ties: 7,
        wc_champs: 0,
        success_rating: 184,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.687,
          39.809
        ]
      },
      properties: {
        country_name: "Korea DPR",
        wc_playedin: 2,
        wc_wins: 1,
        wc_losses: 5,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 38,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -8.027,
          40.075
        ]
      },
      properties: {
        country_name: "Portugal",
        wc_playedin: 6,
        wc_wins: 14,
        wc_losses: 9,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 239,
        third_place_wins: 1,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          34.786,
          31.148
        ]
      },
      properties: {
        country_name: "Israel",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 1,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 24,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.609,
          32.805
        ]
      },
      properties: {
        country_name: "Morocco",
        wc_playedin: 4,
        wc_wins: 2,
        wc_losses: 7,
        wc_ties: 4,
        wc_champs: 0,
        success_rating: 80,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -88.742,
          13.621
        ]
      },
      properties: {
        country_name: "El Salvador",
        wc_playedin: 2,
        wc_wins: 0,
        wc_losses: 6,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 35,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          143.717,
          -29.802
        ]
      },
      properties: {
        country_name: "Australia",
        wc_playedin: 4,
        wc_wins: 2,
        wc_losses: 8,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 68,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -72.205,
          19.206
        ]
      },
      properties: {
        country_name: "Haiti",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 20,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.76,
          51.466
        ]
      },
      properties: {
        country_name: "German DR",
        wc_playedin: 1,
        wc_wins: 2,
        wc_losses: 2,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 42,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          23.881,
          -1.588
        ]
      },
      properties: {
        country_name: "Democratic Republic of the Congo",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 20,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          55.567,
          32.048
        ]
      },
      properties: {
        country_name: "IR Iran",
        wc_playedin: 3,
        wc_wins: 0,
        wc_losses: 4,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 44,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.562,
          35.211
        ]
      },
      properties: {
        country_name: "Tunisia",
        wc_playedin: 4,
        wc_wins: 1,
        wc_losses: 7,
        wc_ties: 4,
        wc_champs: 0,
        success_rating: 64,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          55.567,
          32.048
        ]
      },
      properties: {
        country_name: "Iran",
        wc_playedin: 3,
        wc_wins: 1,
        wc_losses: 4,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 48,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.621,
          5.125
        ]
      },
      properties: {
        country_name: "Cameroon",
        wc_playedin: 7,
        wc_wins: 4,
        wc_losses: 12,
        wc_ties: 7,
        wc_champs: 0,
        success_rating: 130,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          169.857,
          -44.774
        ]
      },
      properties: {
        country_name: "New Zealand",
        wc_playedin: 2,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 31,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.493,
          29.409
        ]
      },
      properties: {
        country_name: "Algeria",
        wc_playedin: 4,
        wc_wins: 3,
        wc_losses: 7,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 74,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -86.539,
          14.698
        ]
      },
      properties: {
        country_name: "Honduras",
        wc_playedin: 3,
        wc_wins: 0,
        wc_losses: 6,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 41,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          47.386,
          29.465
        ]
      },
      properties: {
        country_name: "Kuwait",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 2,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 17,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          44.269,
          32.338
        ]
      },
      properties: {
        country_name: "Iraq",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 15,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.335,
          56.214
        ]
      },
      properties: {
        country_name: "Denmark",
        wc_playedin: 4,
        wc_wins: 8,
        wc_losses: 6,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 104,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -104.956,
          53.407
        ]
      },
      properties: {
        country_name: "Canada",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 15,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -7.721965,
          52.914604
        ]
      },
      properties: {
        country_name: "Ireland",
        wc_playedin: 3,
        wc_wins: 2,
        wc_losses: 5,
        wc_ties: 6,
        wc_champs: 0,
        success_rating: 64,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          54.612,
          23.946
        ]
      },
      properties: {
        country_name: "United Arab Emirates",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 15,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -83.868,
          9.977
        ]
      },
      properties: {
        country_name: "Costa Rica",
        wc_playedin: 4,
        wc_wins: 6,
        wc_losses: 7,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 92,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          44.194,
          24.981
        ]
      },
      properties: {
        country_name: "Saudi Arabia",
        wc_playedin: 4,
        wc_wins: 2,
        wc_losses: 9,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 61,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          99.313,
          64.674
        ]
      },
      properties: {
        country_name: "Russia",
        wc_playedin: 3,
        wc_wins: 2,
        wc_losses: 5,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 51,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          21.835,
          39.739
        ]
      },
      properties: {
        country_name: "Greece",
        wc_playedin: 3,
        wc_wins: 2,
        wc_losses: 7,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 49,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.831,
          8.557
        ]
      },
      properties: {
        country_name: "Nigeria",
        wc_playedin: 5,
        wc_wins: 5,
        wc_losses: 10,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 91,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          24.258,
          -29.629
        ]
      },
      properties: {
        country_name: "South Africa",
        wc_playedin: 3,
        wc_wins: 2,
        wc_losses: 3,
        wc_ties: 4,
        wc_champs: 0,
        success_rating: 50,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.099,
          36.492
        ]
      },
      properties: {
        country_name: "Japan",
        wc_playedin: 5,
        wc_wins: 4,
        wc_losses: 10,
        wc_ties: 3,
        wc_champs: 0,
        success_rating: 80,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.525,
          45.694
        ]
      },
      properties: {
        country_name: "Croatia",
        wc_playedin: 4,
        wc_wins: 7,
        wc_losses: 7,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 141,
        third_place_wins: 1,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -77.389,
          18.202
        ]
      },
      properties: {
        country_name: "Jamaica",
        wc_playedin: 1,
        wc_wins: 1,
        wc_losses: 2,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 16,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -15.131,
          14.965
        ]
      },
      properties: {
        country_name: "Senegal",
        wc_playedin: 1,
        wc_wins: 2,
        wc_losses: 1,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 33,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.832,
          46.16
        ]
      },
      properties: {
        country_name: "Slovenia",
        wc_playedin: 2,
        wc_wins: 1,
        wc_losses: 4,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 28,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -77.749,
          -1.075
        ]
      },
      properties: {
        country_name: "Ecuador",
        wc_playedin: 3,
        wc_wins: 4,
        wc_losses: 5,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 56,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          111.411,
          30.905
        ]
      },
      properties: {
        country_name: "China PR",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 10,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.591,
          8.307
        ]
      },
      properties: {
        country_name: "Cote d'Ivoire",
        wc_playedin: 3,
        wc_wins: 3,
        wc_losses: 5,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 50,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          15.437,
          49.922
        ]
      },
      properties: {
        country_name: "Czech Republic",
        wc_playedin: 1,
        wc_wins: 1,
        wc_losses: 2,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 16,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.105,
          7.333
        ]
      },
      properties: {
        country_name: "Ghana",
        wc_playedin: 3,
        wc_wins: 4,
        wc_losses: 6,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 65,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.083,
          8.042
        ]
      },
      properties: {
        country_name: "Togo",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 10,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          30.319,
          49.519
        ]
      },
      properties: {
        country_name: "Ukraine",
        wc_playedin: 1,
        wc_wins: 3,
        wc_losses: 2,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 35,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -61.233,
          10.321
        ]
      },
      properties: {
        country_name: "Trinidad and Tobago",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 2,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 12,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          20.299265,
          43.703475
        ]
      },
      properties: {
        country_name: "Serbia and Montenegro",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 3,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 10,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          17.481,
          -11.234
        ]
      },
      properties: {
        country_name: "Angola",
        wc_playedin: 1,
        wc_wins: 0,
        wc_losses: 1,
        wc_ties: 2,
        wc_champs: 0,
        success_rating: 14,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          19.324,
          48.842
        ]
      },
      properties: {
        country_name: "Slovakia",
        wc_playedin: 1,
        wc_wins: 1,
        wc_losses: 2,
        wc_ties: 1,
        wc_champs: 0,
        success_rating: 18,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          20.722,
          44.454
        ]
      },
      properties: {
        country_name: "Serbia",
        wc_playedin: 1,
        wc_wins: 1,
        wc_losses: 2,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 16,
        third_place_wins: 0,
        second_place: 0
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          17.942,
          44.329
        ]
      },
      properties: {
        country_name: "Bosnia and Herzegovina",
        wc_playedin: 1,
        wc_wins: 1,
        wc_losses: 2,
        wc_ties: 0,
        wc_champs: 0,
        success_rating: 16,
        third_place_wins: 0,
        second_place: 0
      }
    }
  ]
}